import React, { Component } from 'react';
import HeaderBread  from '../../layout/Header_Bread'
import { Dropdown, Label, Divider, Form, Header, Message,Button, Icon} from 'semantic-ui-react'
import { Grid, Container } from 'semantic-ui-react'
import {Step1a_Edit} from './Step1a_Edit'
import {Step2a_Edit} from './Step2a_Edit'
import {Step3a_Edit} from './Step3a_Edit'
import {Consumer, MyContext} from '../../../../context/Context'
import axios from '../../../../services/AxiosOrders'


import FileLogTable from '../../filepod/FileLogTable'


// import history from '../../../router/history'
// import { Redirect } from 'react-router-dom'
// import UploadImage from '../../filepod/UploadImage' 
// const uuid = require('uuid/v4');
// import {useLocation} from 'react-router'
// import { createBrowserHistory } from "history";

// const history = createBrowserHistory({ basename: '/path' })
// const location = useLocation()

class MasterFormEdit extends Component {
  constructor(props) {
    super(props)
    // this.service = this.service.bind(this)
    this.state = {

      name:'',
      mrn:'',
      gender:'',
      dob:'',
      age:'',
      // oid:'',
      logsGroupId: '',
      filesGroupId: '',

      key:'1',
      currentStep: 1,
      service: '',
      imgUrl:  '',
      heading: '',
      text: '', 
      title:'',
      description:'',
      members:{},
      email:'',
      payment:'',
      price:'',
      voucher:'',
      errors: {},
      cardId:this.props.card.cardId,
    //   toDashboard: false
    }
    // const customHistory = createBrowserHistory();
  }

 

 async  componentDidMount() {

    // console.log('history --line 92')
    // console.log(this.props.history)

    // console.log(this.props)

    try{
 

  // console.log(this.props)
  // let  id  = this.props.match.params.id;
  // id  = this.props.match.params.id;

//   const resp = await axios.get(`${auth.localId}/cards.json?auth=${auth.token}`);
// console.log(' this.props.match.params.id;')
// console.log( this.props.match.params.id)
// console.log(this.props.card.cardId)
// console.log(this.props.oid)
//   let resp = await axios.get(`cards.json?${id}&auth=${this.context.auth.token}`);
// let resp = await axios.get(`${this.context.auth.localId}/cards/${id}.json?&auth=${this.context.auth.token}`);

let resp = await  axios.get(`groups/${this.props.oid}/cards/${this.props.card.cardId}.json?&auth=${this.context.auth.token}`);


// let resp =await axios.get(`/${this.context.auth.localId}/cards/${id}.json&auth=${this.context.auth.token}`);

    // let resp =await axios.get(`${this.context.auth.localId}/cards/${id}.json?auth=${this.context.auth.token}`);

    // console.log('resp')
    // console.log(resp)
    // // const card = resp.data[id];
    const card = resp.data;
    // console.log('card------------------------------------1')
    // console.log(card)
    // console.log('this.context----------------------------')
    // console.log(this.context)
    // console.log('files----------------------------------')
    // console.log(card.files)
    // console.log('logs------------------------------------------')
    // console.log(card.files)

    // console.log('id------------------------------------1')
    // console.log(id)
    // console.log('this.context.auth.localId')
    // console.log(this.context.auth.localId)
    this.setState({
      
      name:card.name,
      mrn:card.mrn,
      gender:card.gender,
      dob:card.dob,
      age:card.age,
      // oid:card.oid,
        heading: card.heading,
        text: card.text,
        imgUrl: card.imgUrl,
        service: card.service,
        heading: card.heading,
        title: card.title,
        description: card.description,
        email: card.email,
        payment: card.payment,
        price: card.payment ,
        voucher: card.voucher,
        files: card.files,
        logsGroupId: card.logsGroupId,
        filesGroupId: card.filesGroupId,
        logs: card.logs,
        cardId: card.cardId
      });

  if (!this.props.match.isExact) {
      throw Error('There is an error');
    }
    // id  = this.props.match.params.id;
    const id = this.props.card.cardId
    //  resp = await axios.get(`/cards.json?${id}&auth=${this.context.auth.token}`);
    //  resp = await axios.get(`${this.context.auth.localId}/cards/${id}.json?&auth=${this.context.auth.token}`);
     resp = await  axios.get(`groups/${this.props.oid}/cards/${this.props.card.cardId}.json?&auth=${this.context.auth.token}`);

 
    card = resp.data;

      this.setState({
        heading: card.heading,
        text: card.text,
        imgUrl: card.imgUrl,
        service: card.service,
        heading: card.heading,
        title: card.title,
        description: card.description,
        email: card.email,
        payment: card.payment,
        price: card.payment ,
        voucher: card.voucher,
        files: card.files,
        logsGroupId: card.metadataFile,
        filesGroupId: card.filesGroupId,
        logs: card.logs,
        cardId:  this.props.card.cardId


      });
    }
    catch (error) {
    //   console.log(error);
    }
}

  onChange = e => this.setState({ [e.target.name]: e.target.value });

  onSubmit = async (dispatch, auth, e) => {
    e.preventDefault();

    // const { cardId, imgUrl, heading, text, title, description, payment, email, voucher , service , files, metadataFile,logs   } = this.state;
    const { mrn, gender, dob, age, name, imgUrl, heading, text, title, description, email, voucher , service , files, logsGroupId, filesGroupId, logs   } = this.state;
 

    const updCard = {
      cardId: this.props.card.cardId, 
      draft: true, 
      projectStarted: true,
      projectCompleted: false,
      filesGroupId,
      logsGroupId,
      gender,
      mrn,
      name,
      dob,
      age,
      imgUrl,
      service, 
      heading,
      imgUrl,
      text,
      title,
      description,
      voucher,
      email,
      userId: auth.localId,
      files,
      // metadataFile,
      logs,
      date: new Date(),
    };



    //  resp = await axios.get(`/cards.json?${id}&auth=${this.context.auth.token}`);
      // const resp = await axios.put(`/cards/${id}.json?auth=${auth.token}`,updCard);

    // const resp = await axios.put(`${this.context.auth.localId}/cards/${this.props.card.cardId}.json?&auth=${this.context.auth.token}`,updCard );
    const resp = await  axios.put(`groups/${this.props.oid}/cards/${this.props.card.cardId}.json?&auth=${this.context.auth.token}`, updCard);


    const id = this.props.cardId
      dispatch({ type: 'UPDATE_CARD', payload: { ...resp.data, id } });

 
  };

  handleChange = event => {
    const {name, value} = event.target
    this.setState({
      [name]: value
    })    
  }
    


DropdownExampleSelection = (onChange, value) => (
    <Dropdown 
      placeholder='Select a  Service'
      fluid
      selection
      // defaultValue={serviceOptions[0].text}
      defaultValue={this.state.service}
      options={serviceOptions}
      onChange={(e, { value }) => this.handleMenuChange(value)} />)
   
  handleMenuChange = value =>{
    //  alert(value)
     this.service = value

     this.setState({
        service: value
      })
    // console.log(serviceOptions[0].text)
  }

  _next = () => {
    let currentStep = this.state.currentStep
    currentStep = currentStep >= 2? 3: currentStep + 1
    this.setState({
      currentStep: currentStep
    })
  }
    
  _prev = () => {
    let currentStep = this.state.currentStep
    currentStep = currentStep <= 1? 1: currentStep - 1
    this.setState({
      currentStep: currentStep
    })
  }
 

previousButton() {
  let currentStep = this.state.currentStep;
  if (currentStep !== 1) {
    return (
    //   <Button fluid size='big'  style={{width:"27%", float:"left", marginRight:"2vw"}}
    //     type="button" onClick={this._prev}   >
    //     Previous
    // </Button>

    <Button icon labelPosition='left'    type="button" onClick={this._prev}  
       style={{width:"15%", padding: '0px', float:"left", marginLeft:"2vw", height:"50%"}}>
    
    <Icon  size='large'  name='chevron left' />
    {/* Previous */}
  </Button>
    )
  }
  return null;
}


nextButton() {

  let currentStep = this.state.currentStep;
  if (currentStep < 3) {
    return (
    //   <Button  fluid color='teal' size='big'  style={{width:"27%", float: "right"}}
    //     type="button" onClick={this._next}>
    //     Next
    // </Button>

    <Button icon labelPosition='right' type="button" onClick={this._next}  
       style={{width:"15%", padding: '0px', float:"right", marginRight:"2vw", height:"50%"}}>
    
    <Icon  size='large'  name='chevron right' />
    {/* Previous */}
  </Button>

  
    )
  }
  return null;
}

  
//   render() {   
    render() {
        // const { imgUrl, heading, text, title, description, members, payment, price, voucher, errors } = this.state;
        // if (this.state.toDashboard) {
        //   return <Redirect to="/cardlist" />;
        // } 
    return (
        <Consumer>
        {value => {
          const { dispatch, auth } = value;
          return (

      <React.Fragment>
      {/* <h1>React Wizard Form 🧙‍♂️</h1> */}

      {/* <Button floated='left' style={{height:"400px", width:"150px"}}
        type="button"  onClick={() => this.props.history.goBack()}>
      Back To DashBoard
      </Button> */}

                    {/* <input
                        type="button"
                        value="Back"
                        className="btn btn-lg btn-secondary btn-block m-0 ml-1"
                        onClick={() => this.props.history.goBack()}/>  */}
                        
                        {/* <HeaderBread></HeaderBread> */}
      <Container >
     <Label color='teal' ribbon='right' > Draft </Label>
     {/* <Divider /> */}
     <Grid>
      <Grid.Column floated='left' width={11}>
 

        
          {/* <Header>Select a Service</Header> */}
                  {/* {this.DropdownExampleSelection()} */}
                  {/* <Divider /> */}
        {this.state.key === serviceOptions[0].key ? (
        <React.Fragment>
            <Form onSubmit={e => this.onSubmit(dispatch, auth, e)}>

  <Grid>
      
          <Button   inverted  color="blue"
          
          size='huge' style={{
         
         float:"left",
     margin:'auto',
     width: "30vw",  height:"4vw", minWidth: "25vw", minHeight:"6.5vh"
     // marginLeft:"20px", marginRight:"10px",
        // height:"4vw", minHeight:"50px"
 
   
   }} animated='fade'   >
   <Button.Content color="teal" visible>Update Edits</Button.Content>
   <Button.Content color="teal" hidden>S A V E</Button.Content>
   </Button>

          {/* <Button   inverted color='blue'    
                  style={{
                      margin:'auto',
                        width: "11vw",  height:"7vw", minWidth: "200px", minHeight:"50px"
                    }} 
                    // onClick={(e) => this.handleMenuChange(serviceOptions[0].text)} 
                    
                    >
                        Healthcare Brief
                        </Button> */}

{/*  */}
      
 
   
          </Grid>
    
          <br/>
          <Divider/>
            <Message style={{
                            background: "transparent",
                            border: "0px solid transparent",
                            boxShadow: "none",
                            padding: "0px",
                            height: "5vw",
                            marginBottom:'0px',
                            // marginLeft: "1.2vw",
                            
                            minHeight: "100px",
                            // textAlign: "left"
                          }}>
                          
                          {this.previousButton()}
                            {this.nextButton()}
       
                            </Message>

            <Step1a_Edit
            currentStep={this.state.currentStep} 
            handleChange={this.onChange}
            // imgUrl={this.state.imgUrl}
            // title={this.state.title}
            // description={this.state.description}
            
            title={this.state.title}

            dob={this.state.dob}
            gender={this.state.gender}
            mrn={this.state.mrn}
            name={this.state.name}
            heading={this.state.heading}
            description={this.state.description}
            age = {this.state.age}
            />
            <Step2a_Edit
            currentStep={this.state.currentStep} 
            handleChange={this.onChange}
            // heading={this.state.heading}
            cardId = { this.props.card.cardId }
            oid={this.props.oid}
            filelogid = {this.props.card.filesGroupId}
            // email = {this.state.email}
            />
            <Step3a_Edit
            // currentStep={this.state.currentStep} 
            // handleChange={this.onChange}
            // text={this.state.text}
            // price={this.state.price}
            // payment={this.state.payment} 
            // voucher={this.state.voucher}

            currentStep={this.state.currentStep}
            handleChange={this.onChange}
            // text={this.state.text}
            // price={this.state.price}
            // payment={this.state.payment}
            // voucher={this.state.voucher} 
            oid={this.props.oid}
            // auth={this.props.auth} 
            filelogid = {this.props.card.filesGroupId}
           
            />
            {/* {this.previousButton()}
            {this.nextButton()} */}

            </Form>
        </React.Fragment>
        ) : (
            <React.Fragment>
        {this.state.key === serviceOptions[0].key ? (
        <React.Fragment>
            
            <p>Project Draft</p>
            </React.Fragment>
        ): (
            <React.Fragment>
            
            <p>Select a Service</p>
            </React.Fragment>
        )}
        </React.Fragment>
        )}
  

      </Grid.Column>

      <Grid.Column floated='right' width={5} style={{padding:'0px'}}  >
                        
                        {/* <Tester auth={this.props.auth} filesGroupId={this.filesGroupId}></Tester> */}
                        <FileLogTable    filesGroupId={this.props.card.filesGroupId}    oid={this.props.oid} />
  
   
                          
    

    {/* <Message icon='image'
            header='Attach an Image or File'
            content='Drag and Drop or Select' />
                  {/* <Navbar></Navbar> */}
                  {/* <UploadImage style={{marginTop:"1px"}}  props={this.props}></UploadImage> */}
                  {/* <Divider />  */}

       </Grid.Column>
      </Grid>
      </Container>
      </React.Fragment>
        );
    }}
    </Consumer>
    );
  }
}



const serviceOptions = [
    {
      key: '1',
      text: 'eResponse: Radiology chest xray pneumonia detection [ Seeking FDA Approval ]',
      value: 'eResponse: Radiology chest xray pneumonia detection [ Seeking FDA Approval ]',
      image: { avatar: true, src:'/images/avatar/small/elliot.jpg' },
      size: 'small',
    },
    {
      key: '2',
      text: 'Draft: Project Delivery',
      value: 'Draft: Project Delivery',
      image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
      size: 'small',
    },
    {
        key: '3',
        text: 'Select a Service',
        value: 'Draft: Project Delivery',
        image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
        size: 'small',
      },
  ]


MasterFormEdit.contextType = MyContext;
export default  MasterFormEdit;